export const REQUEST_USAGE_CLAIMS: string = 'REQUEST_USAGE_CLAIMS';
export const SET_USAGE_CLAIMS: string = 'SET_USAGE_CLAIMS';
